import React, { useEffect, useContext, useRef, useState } from "react";
import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from "../context/BasicContext";
type ChartBProps = {
    /*
    hasDetail?: boolean,
    setOpen?: boolean,
    setClose?: () => void,
    */
    CurrentYear: number
    ActType: string

}

type ResData = {
    ActType:string 
    LFirstDate:string
    RFirstDate:string
    UID:string
    已取得時數:number
    應規定時數:number
    未完科目時數:number
    科目標準總時數:number
    第幾年度:number
}

export default (props: ChartBProps) => {
    const bc = useContext(BasicContext)
    const ws = useContext(WebServiceContext)

    const [isCompleteTotal, setIsCompleteTotal] = useState<number>(0)

    //const [resData, setResData] = useState<ResData[]>([])

    const [LR, setLR] = useState<string>("--")
    const [currentYear, setCurrentYear] = useState<number>(0)
    const [currentHR, setCurrentHR] = useState<number>(0)
    const [currentLeftHR, setCurrentLeftHR] = useState<number>(0)

    useEffect(() => {
        ws.WebService.getLRStatus(props.ActType).then((res: any) => {
            console.log(res)
            const _d = res.Data[0] as ResData;
            /*
            let ct: number = 0;
            (res.Data as ResData[]).map((item: ResData) => {
                if (item.CompleteDate != null && ( item.RecognizeYear == item.LYear || item.RecognizeYear == item.RYear)) {
                    ct += item.Hours
                }
            })
            setIsCompleteTotal(ct)
            */

            if (props.ActType == "H" || props.ActType == "I") {
                setLR("產")
            } else {
                setLR("壽")
            }

            setCurrentYear(_d.第幾年度)
            setCurrentHR(_d.已取得時數)
            setCurrentLeftHR(_d.未完科目時數)
            setIsCompleteTotal(_d.科目標準總時數)
        })
        return
    }, [])


    return (
        <>
        {
            isCompleteTotal !=0  &&
            <div className="chartB" style={{ backgroundColor: "#fff", padding: 15, margin: 15, fontSize: 24, display: "flex", alignItems: "center", flexDirection: "column" }}>
                <div>
                    {
                        
                        isCompleteTotal ==  currentHR?
                            <span>
                                恭喜!您已經完成
                                <span style={{ color: "#f00" }}>{LR}</span>
                                險第{currentYear}年度的所有課程。</span>
                            :
                            <span>
                                {LR}險第<span style={{ color: "#f00" }}>{currentYear}</span>年度：目前已完成<span style={{ color: "#f00" }}>{currentHR}</span>小時的課程，尚有<span style={{ color: "#f00" }}>{currentLeftHR}</span>小時的課程。
                            </span>
                    }
                </div>
              
            </div>
    }
        </>
    )

}
